import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import Edit from "@material-ui/icons/Edit";
import Publish from "@material-ui/icons/Publish";
import Delete from "@material-ui/icons/Delete";
import ListItemMenu from "../../../components/Menu/ListItemMenu";
import NoContent from "../../../components/NoContent";
import MetricIconPreview from "./MetricIconPreview";
import { METRIC_CATEGORY, truncateMetricText } from "./metricOptions";

const useStyles = makeStyles(() => ({
  paper: {
    padding: "8px 0",
  },
  primaryRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px",
    // Leaves room to the right for the single action menu in
    // ListItemSecondaryAction, which only ever holds that one element.
    paddingRight: "40px",
  },
  reachValue: {
    color: "#E00186",
    fontWeight: 700,
    fontSize: "1.15rem",
  },
  statusChip: {
    marginLeft: "auto",
    textTransform: "capitalize",
  },
  skeletonRow: {
    height: 48,
    margin: "8px 16px",
  },
}));

const getStatusChipColor = (status) =>
  status === "published" ? "primary" : "default";

const MetricsList = ({ category, items, isLoading, onEdit, onTogglePublish, onDelete }) => {
  const classes = useStyles();
  const isImpact = category === METRIC_CATEGORY.IMPACT;

  if (isLoading) {
    return (
      <Paper className={classes.paper}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} variant="rect" className={classes.skeletonRow} />
        ))}
      </Paper>
    );
  }

  if (items.length === 0) {
    return <NoContent title="No Content" />;
  }

  return (
    <Paper className={classes.paper}>
      <List>
        {items.map((item) => {
          const isPublished = item.status === "published";
          const menu = [
            {
              primary: "Edit",
              icon: <Edit fontSize="small" />,
              onClick: () => onEdit(item),
            },
            {
              primary: isPublished ? "Unpublish" : "Publish",
              icon: <Publish fontSize="small" />,
              onClick: () => onTogglePublish(item),
            },
            {
              primary: "Delete",
              icon: <Delete fontSize="small" />,
              onClick: () => onDelete(item),
            },
          ];

          return (
            <ListItem key={item.id} divider>
              <ListItemText
                primary={
                  <span className={classes.primaryRow}>
                    {isImpact ? (
                      <>
                        <MetricIconPreview iconKey={item.icon} />
                        <span>{truncateMetricText(item.text)}</span>
                      </>
                    ) : (
                      <>
                        <span className={classes.reachValue}>{item.value}</span>
                        <span>{item.title}</span>
                      </>
                    )}
                    <Chip
                      size="small"
                      label={item.status}
                      color={getStatusChipColor(item.status)}
                      className={classes.statusChip}
                    />
                  </span>
                }
              />
              <ListItemSecondaryAction>
                <ListItemMenu menu={menu} />
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default MetricsList;
